<div class="dialog-header">
  <h3 mat-dialog-title class="dialog-title">
    Guide to filetypes and translation assets
  </h3>
  <button class="close-x" (click)="close()" aria-label="Close dialog">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
        fill="white"
      />
    </svg>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <p class="dialog-intro">Supported file types:</p>

  <ul class="filetypes-list">
    <li>
      <strong>Source files (preferred):</strong> docx, xlsx, pptx, csv, dita,
      pot, idml (InDesign), html, xml, json, yaml/yml, xlf/xliff (v1.x), txt,
      md/ markdown, strings, stringsdict, properties, resx, resw, ts
    </li>
    <li>
      <strong>PDFs:</strong> Supported, but
      <strong>please upload source files</strong> when possible for best results
    </li>
    <li>
      <strong>Illustrator (ai):</strong> Supported on an exception basis—please
      contact
      <a href="mailto:aztranslate@astrazeneca.com" class="email-link"
        >aztranslate&#64;astrazeneca.com</a
      >
    </li>
    <li>
      <strong>Presentations:</strong> ppt/pptx supported; exporting to pdf is
      also possible if needed
    </li>
    <li>
      <strong>Video subtitling:</strong> Provide srt caption files (Nucleus
      Video can supply). If no srt is available and captions are burnt into the
      video, a linguistic supplier is required
    </li>
    <li>
      <strong>E-learning (SCORM):</strong> Supported. If built in Articulate
      Storyline or Adobe Captivate, ask your production partner for xliff or a
      doc for translation; if built elsewhere, request html from your partner
    </li>
  </ul>
</mat-dialog-content>
